import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert, Spinner, Modal } from "react-bootstrap";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { supabase } from "../supabaseClient/supabaseClient";
import { FaEnvelope, FaLock, FaKey } from "react-icons/fa";
import "./Uyeol.css"; // Reuse the premium CSS

const Uyegirisi = () => {
  // Giriş State'leri
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  
  // Şifre Sıfırlama State'leri
  const [showResetModal, setShowResetModal] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetLoading, setResetLoading] = useState(false);
  const [resetMsg, setResetMsg] = useState({ type: "", text: "" });

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const redirectPath = queryParams.get("redirect") || "/Index";

  // --- GİRİŞ İŞLEMİ ---
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg(null);

    try {
      const { error } = await supabase.auth.signInWithPassword({
        email: email,
        password: password,
      });

      if (error) throw error;

      navigate(redirectPath);

    } catch (error) {
      setErrorMsg("Giriş bilgileri hatalı. Lütfen e-posta ve şifrenizi kontrol ediniz.");
    } finally {
      setLoading(false);
    }
  };

  // --- ŞİFRE SIFIRLAMA İŞLEMİ ---
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setResetLoading(true);
    setResetMsg({ type: "", text: "" });

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(resetEmail, {
        redirectTo: window.location.origin + "/SifreGuncelle", 
      });

      if (error) throw error;

      setResetMsg({ 
        type: "success", 
        text: "Sıfırlama bağlantısı e-posta adresinize gönderildi. Lütfen gelen kutunuzu (ve spam klasörünü) kontrol edin." 
      });

    } catch (error) {
      setResetMsg({ type: "danger", text: "İşlem sırasında bir hata oluştu. Lütfen tekrar deneyiniz." });
    } finally {
      setResetLoading(false);
    }
  };

  // Modal kapandığında state'leri temizle
  const handleCloseModal = () => {
    setShowResetModal(false);
    setResetMsg({ type: "", text: "" });
    setResetEmail("");
  };

  return (
    <div className="auth-page-wrapper">
      <div className="auth-bg-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
      </div>
      
      <Container className="auth-container">
        <Row className="justify-content-center">
          <Col md={8} lg={5} xl={4}>
            <div className="auth-card shadow-2xl">
              
              <div className="auth-header text-center mb-4">
                <h2 className="auth-title">Hoş Geldiniz</h2>
                <p className="auth-subtitle">Hesabınıza giriş yaparak devam edin</p>
              </div>
              
              {errorMsg && (
                <Alert variant="danger" className="auth-alert border-0 shadow-sm d-flex align-items-center mb-4">
                  {errorMsg}
                </Alert>
              )}
              
              <Form onSubmit={handleLogin} className="auth-form">
                <Form.Group className="mb-4" controlId="formEmail">
                  <Form.Label className="auth-label">E-posta Adresi</Form.Label>
                  <div className="input-with-icon">
                    <FaEnvelope className="input-icon" />
                    <Form.Control 
                      type="email" 
                      placeholder="ornek@mail.com" 
                      value={email} 
                      onChange={(e) => setEmail(e.target.value)} 
                      required 
                      className="auth-input"
                    />
                  </div>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formPassword">
                  <Form.Label className="auth-label">Şifre</Form.Label>
                  <div className="input-with-icon">
                    <FaLock className="input-icon" />
                    <Form.Control 
                      type="password" 
                      placeholder="••••••••" 
                      value={password} 
                      onChange={(e) => setPassword(e.target.value)} 
                      required 
                      className="auth-input"
                    />
                  </div>
                </Form.Group>

                <div className="text-end mb-4">
                  <Button 
                    variant="link" 
                    className="p-0 border-0 bg-transparent shadow-none"
                    style={{ color: "#64748b", textDecoration: "none", fontSize: "0.85rem", fontWeight: "600" }}
                    onClick={() => setShowResetModal(true)}
                    onMouseEnter={(e) => e.target.style.color = '#001f3f'}
                    onMouseLeave={(e) => e.target.style.color = '#64748b'}
                  >
                    Şifremi unuttum?
                  </Button>
                </div>

                <Button 
                  type="submit" 
                  disabled={loading} 
                  className="auth-submit-btn w-100 mb-4"
                >
                  {loading ? (
                    <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" /> Giriş Yapılıyor...</>
                  ) : (
                    "Giriş Yap"
                  )}
                </Button>
              </Form>

              <div className="auth-footer text-center">
                <p className="text-muted mb-0">
                  Henüz hesabınız yok mu?{' '}
                  <Link to="/Uyeol" className="auth-link fw-bold">
                    Ücretsiz Kayıt Ol
                  </Link>
                </p>
              </div>

            </div>
          </Col>
        </Row>
      </Container>

      {/* --- ŞİFRE SIFIRLAMA MODALI --- */}
      <Modal show={showResetModal} onHide={handleCloseModal} centered backdrop="static">
        <Modal.Header closeButton className="border-0 pb-0">
        </Modal.Header>
        <Modal.Body className="px-4 pb-4">
          <div className="text-center mb-4">
            <div className="success-icon-wrapper mx-auto mb-3" style={{ background: 'rgba(13, 110, 253, 0.1)', width: '60px', height: '60px' }}>
              <FaKey style={{ fontSize: '24px', color: '#0d6efd' }} />
            </div>
            <h4 className="fw-bold" style={{ color: '#001f3f' }}>Şifrenizi mi Unuttunuz?</h4>
            <p className="text-muted small px-2">
              Kayıtlı e-posta adresinizi girin, size şifrenizi sıfırlamanız için güvenli bir bağlantı gönderelim.
            </p>
          </div>
          
          {resetMsg.text && (
            <Alert variant={resetMsg.type} className="auth-alert border-0 shadow-sm">
              {resetMsg.text}
            </Alert>
          )}

          <Form onSubmit={handleResetPassword}>
            <Form.Group className="mb-4">
              <Form.Label className="auth-label">E-posta Adresi</Form.Label>
              <div className="input-with-icon">
                <FaEnvelope className="input-icon" />
                <Form.Control 
                  type="email" 
                  placeholder="ornek@mail.com" 
                  value={resetEmail} 
                  onChange={(e) => setResetEmail(e.target.value)} 
                  required 
                  className="auth-input"
                />
              </div>
            </Form.Group>
            
            <Button 
              type="submit" 
              disabled={resetLoading} 
              className="auth-submit-btn w-100"
            >
              {resetLoading ? <Spinner size="sm" animation="border" /> : "Sıfırlama Bağlantısı Gönder"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

    </div>
  );
};

export default Uyegirisi;